module.exports = __webpack_public_path__ + "img/HeartBeat.8981c20c.svg";